<template>
  <div id="preview" v-if="prods">
    <div class="printTitle">{{date}} {{label}}</div>
    <div class="printCount">
      <div></div>
      <div>種類: {{cate.length}} 種</div>
      <div>品項: {{[].concat(...cate.map(e => e.items)).length}} 項</div>
      <div>總數量: {{[].concat(...[].concat(...cate.map(e => e.items))).map(e => e.count).reduce((a, b) => a + b, 0)}} 個</div>
      <div></div>
    </div>
    <div class="printBody">
      <div class="eachItem" v-for="(row, r) in cate" :key="r">
        <div>
          <div>{{row._id}}</div>
          <div>共計: {{[].concat(...row.items).map(e => e.count).reduce((a, b) => a + b, 0)}} 組/個</div>
        </div>
        <div class="tableTitle">
          <div>商品名稱</div>
          <div>數量</div>
        </div>
        <template v-for="(item, i) in row.items">
          <div :key="`item-${r}-${i}`">
            <div :style="{fontWeight: '700'}">{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
          <template v-if="bySheet==='訂單'">
            <template v-for="(its, j) in item.items">
              <div v-for="(it, k) in its" :key="`item-${r}-${i}-${j}-${k}`" :style="{height: '45px', fontSize:'var(--fonts12)'}">
                <div :style="{paddingLeft:'20px', fontWeight: '400', lineHeight:'1.2em', display:'flex', flexDirection:'column', alignItems:'flex-start'}">
                  <div><span :style="{fontWeight:'700'}">{{j+1}}-{{k+1}}.</span> {{it.name}}</div>
                  <div :style="{marginLeft:'40px'}" v-if="[...(it.opt||[]), ...(it.add || []).map(a => `${a.item.name}${a.price ? ` _+${a.price}` : ''}`), it.remark].filter(e => e).length>0">{{[...(it.opt||[]), ...(it.add || []).map(a => `${a.item.name}${a.price ? ` _+${a.price}` : ''}`), it.remark].filter(e => e).join(' | ')}}</div>
                </div>
                <div>{{it.count}}</div>
              </div>
            </template>
          </template>
          <template v-else-if="bySheet==='單品'">
            <template v-for="(it, j) in item.tids_items">
            <div :key="`item-${r}-${i}-${j}`" :style="{height: '45px', fontSize:'var(--fonts12)'}">
              <div :style="{paddingLeft:'20px', fontWeight: '500'}">{{String.fromCharCode(97+j)}}. {{it.name}}</div>
              <div>{{it.count}}</div>
            </div>
            <template v-if="!(it.ops.length===1&&it.ops[0].opt==='')">
            <div v-for="(op, o) in it.ops" :key="`item-${r}-${i}-${j}-${o}`" :style="{fontSize:'var(--fonts12)', height: '45px'}">
              <div :style="{paddingLeft:'40px'}">{{o+1}}. {{op.opt || '基礎'}}</div>
              <div>{{op.count}}</div>
            </div>
            </template>
          </template>
        </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['prods', 'adds', 'label', 'date', 'cate', 'bySheet']

}
</script>
<style>
:root {
  --fonts11: calc(11mm * 0.4);
  --fonts12: calc(12mm * 0.4);
  --fonts14: calc(14mm * 0.4);
  --fonts16: calc(16mm * 0.4);
  --fonts18: calc(18mm * 0.4);
}
</style>
<style scoped>
.printTitle {
  font-size: var(--fonts18);
  text-align: center;
  margin-inline: auto;
  letter-spacing: .2em;
}
.printBody {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}
.printCount {
  display: flex;
  border: 1px solid #000000;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 15px;
  font-size: var(--fonts14);
  line-height: 1.8em;
  margin-top: 15px;
}
.eachItem {
  border: 1px solid #000000;
}
.eachItem>div {
  display: flex;
  padding-inline: 15px;
  align-items: center;
  justify-content: space-between;
  font-size: var(--fonts14);
  line-height: 2.8em;
  font-weight: 500;
}
.eachItem>div:nth-child(1) {
  border-bottom: 1px solid;
  line-height: 2em;
  font-weight: 400;
}
.eachItem>div:nth-child(2) {
  line-height: 2em;
  font-size: var(--fonts12);
  color: #FFFFFF;
  background-color: #8C8C8C;
  font-weight: 400;
}

</style>
<style scoped>
#preview {
  position: fixed;
  top: 90px;
  /* left: 70px; */
  left: calc(70px + 100vw);
  width: 210mm;
  height: 297mm;
  background-color: #FFFFFF;
  z-index: 100;
  overflow-y: auto;
  padding: 10mm;
}
</style>
